import { useEffect, useState, type ChangeEvent } from 'react';
import { PhoneFilters, ShivarOption } from '../types';
import { VoiceTextInput } from './VoiceTextInput';

interface FilterBarProps {
  filters: PhoneFilters;
  onChange: (filters: PhoneFilters) => void;
  includeAdminFilters?: boolean;
  options: {
    shivars: ShivarOption[];
  };
}

const Select = ({
  label,
  value,
  options,
  onChange,
}: {
  label: string;
  value: string;
  options: ShivarOption[];
  onChange: (value: string) => void;
}) => (
  <div className="flex flex-col">
    <label className="mb-1 text-xs font-medium text-gray-600">
      {label}
    </label>

    <select
      value={value}
      onChange={(e: ChangeEvent<HTMLSelectElement>) =>
        onChange(e.target.value)
      }
      className="rounded border border-gray-300 px-2 py-1.5 text-sm"
    >
      <option value="">All</option>

      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);


export const FilterBar = ({
  filters,
  onChange,
  includeAdminFilters,
  options,
}: FilterBarProps) => {
  const [local, setLocal] = useState(filters);

  useEffect(() => {
    const timer = setTimeout(() => onChange(local), 250);
    return () => clearTimeout(timer);
  }, [local, onChange]);

  const update = (key: keyof PhoneFilters, value: string) =>
    setLocal((prev) => ({
      ...prev,
      [key]: value,
    }));

  // Changed: status options are now ShivarOption[]
  const statusOptions: ShivarOption[] = [
    { value: 'UNDER_REVIEW', label: 'Under Review' },
    { value: 'APPROVED', label: 'Approved' },
    { value: 'BLOCKED', label: 'Blocked' },
  ];

  return (
    <div className="grid grid-cols-1 gap-3 rounded-lg border border-gray-200 bg-white p-4 sm:grid-cols-2 lg:grid-cols-3">
      <VoiceTextInput
        label={'Name'}
        value={local.name ?? ''}
        onChange={(v) => update('name', v)}
      />

      <Select
        label="Shivar"
        value={local.shivar ?? ''}
        options={options.shivars}
        onChange={(v) => update('shivar', v)}
      />

      {includeAdminFilters && (
        <Select
          label="Status"
          value={local.status ?? ''}
          options={statusOptions}
          onChange={(v) => update('status', v)}
        />
      )}
    </div>
  );
};
